import type { IModuleDefinition } from '@platform/core/types';
import type { IModuleDefinitionState } from '@platform/core/types/modularity/IModuleDefinitionState';
import type { IServerDefinitionResult } from '@platform/core/types/modularity/IServerDefinitionResult';

/**
 * Обирає визначення модуля: серверне — авторитетне (воркспейс міг налаштувати модуль у конструкторі), визначення пакета — миттєвий fallback,
 * доки сервер відповідає або коли він недоступний. Без обох — стан завантаження/помилки сервера.
 */
export function chooseDefinition(server: IServerDefinitionResult, pkg: IModuleDefinition | undefined): IModuleDefinitionState {
  if (server.data) return { data: server.data, source: 'server', isLoading: false, error: undefined };
  if (pkg) return { data: pkg, source: 'package', isLoading: false, error: undefined };
  return { data: undefined, source: 'none', isLoading: server.isLoading, error: server.error };
}
